function baseLoginValidator(
  value = '',
  ctx,
  message = 'services::forms.register_account.validation_messages.login.incorrect_format',
) {
  const { path, createError } = ctx

  if (!value.match(/^([a-z])([0-9a-z.-])*$/)) {
    return createError({
      path,
      message,
    })
  }

  if (value.match(/(admin)/)) {
    return createError({
      path,
      message:
        'services::forms.register_account.validation_messages.login.admin_word_restricted',
    })
  }

  return true
}

export default baseLoginValidator
